/**
 * ガイドの進捗（今どのステップか・チェックしたアイテム）をlocalStorageに残す。
 * タブレットでリロードしても続きから再開できるようにするための、共有IDごとの保存。
 * プライベートモードなどで保存できない環境でも、例外を握りつぶして動き続ける。
 */

export interface GuideProgress {
  /** 0=じゅんび画面、1..N=STEP、N+1=かんせい画面。 */
  step: number;
  /** ステップジャンプをどこまで許すかの上限（訪問済みの最大値）。 */
  maxVisited: number;
  /** ブロックID → チェック済みか。 */
  items: Record<string, boolean>;
  updatedAt: string;
}

const KEY_PREFIX = 'tatami-viewer:guide:v1:';

export function loadProgress(shareId: string, stepCount: number): GuideProgress | null {
  try {
    const raw = window.localStorage.getItem(KEY_PREFIX + shareId);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<GuideProgress>;
    if (typeof parsed.step !== 'number') return null;
    const clamp = (value: number) => Math.max(0, Math.min(stepCount + 1, Math.floor(value)));
    const step = clamp(parsed.step);
    return {
      step,
      maxVisited: Math.max(step, clamp(typeof parsed.maxVisited === 'number' ? parsed.maxVisited : step)),
      items: typeof parsed.items === 'object' && parsed.items !== null ? { ...parsed.items } : {},
      updatedAt: typeof parsed.updatedAt === 'string' ? parsed.updatedAt : '',
    };
  } catch {
    return null;
  }
}

export function saveProgress(shareId: string, progress: Omit<GuideProgress, 'updatedAt'>): void {
  try {
    window.localStorage.setItem(
      KEY_PREFIX + shareId,
      JSON.stringify({ ...progress, updatedAt: new Date().toISOString() }),
    );
  } catch {
    // 保存できない環境では、その場限りの進捗として動かす。
  }
}

export function clearProgress(shareId: string): void {
  try {
    window.localStorage.removeItem(KEY_PREFIX + shareId);
  } catch {
    // 消せなくても支障はない。
  }
}
